import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  navItems = [
    { path: '/', label: 'Home' },
    { path: '/pitch-deck', label: 'Pitch Deck' },
    { path: '/signup', label: 'Sign Up' },
    { path: '/about', label: 'About' },
    { path: '/privacy-policy', label: 'Privacy Policy' },
  ];

  get currentYear(): number {
    return new Date().getFullYear();
  }
}
